
import Modal from "../../modal";
import Button from "@/components/atoms/button";
import Typography from "@/components/atoms/typography";

const InsufficientStockOverlay = ({ show = false, toggleOverlay }: { show: boolean, toggleOverlay: Function }) => {

    const closeModal = () => {
        toggleOverlay(false);
    };

    return <Modal
        className="max-w-[90vw] md:max-w-[45vw] mx-auto flex !w-[95vw] max-w-[45vw] flex-col items-center justify-center sm:-mb-11  sm:overflow-auto md:mb-0 md:mt-0 xl:!w-full"
        isOpen={show}
        onRequestClose={closeModal}
        preventScroll={false}
        closeButton={true}
        variant="default"
        centered={true}
        size="fit"
    >
        <div className=" py-[80px] px-[40px] flex flex-col items-center gap-8 md:py-[120px] ">
            <Typography as='h3' className=' text-[32px] leading-[44px] font-bold items-center md:text-[44px] md:leading-[54.34px]'>{"Insufficient Stock"}</Typography>
            <Typography as='p' className="  text-[18px] leading-[24px] font-medium  md:text-[22px] md:leading-[28px]">{"Unfortunately, we do not have stock available for your selected quantity. Please reduce the number in the cart or check again later when new stock is available."}</Typography>
            <Button onClick={closeModal}>Back to Cart</Button>
        </div>
    </Modal>
};

export default InsufficientStockOverlay;
